import { log } from '@/log'
import { Event } from './events'

/**
 * 直接dataLayer.pushしている実装はこのクラスを利用するように修正予定
 * 今後の実装では生でdataLayer.pushを書かないように
 * @see https://github.com/Everforth/growthpalette-front/issues/8639
 */
export class DataLayerService {
  constructor() {
    window.dataLayer = window.dataLayer || []
  }

  /**
   * @param event
   * @param onCompleted 仮にGTMが初期化されていなかったとしてもonCompletedは必ず実行される
   */
  push(event: Event, onCompleted?: () => void) {
    if (onCompleted) {
      this.pushWithCallback(event, onCompleted)
    } else {
      this.pushWithoutCallback(event)
    }
  }

  private pushWithCallback(event: Event, callback: () => void) {
    if (!this.isGtmInitialized()) {
      log.error('GTM is not initialized')
      /**
       * GTMが初期化されていないことは基本的には考えにくいが、仮にそうだった場合
       * - dataLayer.pushは実施する
       *   - GTMが初期化された際にdataLayerのデータは逐次処理されるため
       * - callbackは即時で実行する
       */
      this.pushWithoutCallback(event)
      callback()

      return
    }

    window.dataLayer.push({
      ...event,
      eventCallback: callback,
      eventTimeout: 1000,
    })
  }

  private pushWithoutCallback(event: Event) {
    window.dataLayer.push({
      ...event,
    })
  }

  private isGtmInitialized(): boolean {
    return !!window.google_tag_manager
  }
}
